import { DatePicker, DatePickerProps } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';
import moment, { Moment } from 'moment';
import { DEFAULT_DATE_FORMAT } from '../../utils';

type FormDatePickerProps = DatePickerProps & {
  name: string;
};

export const FormDatePicker = ({ name, format, ...props }: FormDatePickerProps) => {
  const { control } = useFormContext();
  const dateFormat = format ? format.toString() : DEFAULT_DATE_FORMAT;

  // eslint-disable-next-line
  const onChangeInternal = (date: Moment | null, dateString: string, onChange: (...events: any[]) => void) => {
    if (!date) {
      onChange('');
      return;
    }
    onChange(date);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <DatePicker
          format={format}
          value={value ? moment(value, dateFormat) : null}
          onChange={(date, dateString) => onChangeInternal(date, dateString, onChange)}
          {...props}
        />
      )}
    />
  );
};
